import { Badge } from "@mui/material";

import { useKeyPress } from "../../../../../hooks/useKeyPress";
import Option from "./Option";

function DefaultOptions({
	question,
	settings,
	dispatch,
	keysToPress = [],
	...props
}) {
	useKeyPress(keysToPress, (event) => {
		if (
			keysToPress.some((keyToPress) => keyToPress.includes(event.key)) &&
			!props.disabled
		) {
			return toggleElement(event, props.optionKey);
		}
	});

	const toggleElement = (e, key) => {
		if (props.onClick) {
			return props.onClick(e, key);
		}

		if (!dispatch) {
			return props.action(key);
		}

		dispatch(props.action(key));
	};

	const isSettingSelected = (key) => {
		return settings[key];
	};

	const renderIcon = () => {
		if (props.renderIcon) {
			return props.renderIcon(question);
		}

		return props.Icon;
	};

	const renderText = () => (
		<div className="flex flex-col items-center">
			<span className="size-14-light">{props.text}</span>
			<p className="size-12-light text-black-80 m-0">{props.subText ?? "\u00A0"}</p>
		</div>
	);

	const renderContent = () => {
		if (!props.badgeOptions) {
			return (
				<div className="question--options--item">
					{renderIcon()}
					{renderText()}
				</div>
			);
		}

		return (
			<div className="question--options--item">
				<Badge
					{...props.badgeOptions}
					max={9}
					className="question--options--item--badge"
				>
					{renderIcon()}
				</Badge>
				{renderText()}
			</div>
		);
	};

	return (
		<Option
			disabled={props.disabled}
			onClick={(e) => toggleElement(e, props.optionKey)}
			selected={isSettingSelected(props.optionKey)}
			testId={props.testId}
		>
			{renderContent()}
		</Option>
	);
}

export default DefaultOptions;
